import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledDynamicTabbedLayout = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: auto;

  @media screen and (max-width: 576px) {
    & .container {
      max-width: 100vw;
    }
  }
`;

/**
 * Dynamic Tab Panel grid (3-column responsive layout with spacing)
 * Used by DynamicTabbedLayout to render the slots area beneath the banner and tabs.
 */
export const StyledTabPanelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-auto-flow: dense;
  gap: ${toRem(24)};
  margin-top: ${toRem(32)};
  @media ${baseVariables.mediaQuery.md} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media ${baseVariables.mediaQuery.lg} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

/**
 * Each grid item – className controls column/row behavior:
 * - .pos-1 | .pos-2 | .pos-3 → place non-banner items across columns
 * - .banner → spans all three columns
 * - .tall   → spans two rows in height
 * - .square → single row height
 */
export const StyledTabPanelItem = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  /* Ensure inner cards can shrink within the grid item on small screens */
  > * {
    min-width: 0;
    width: 100%;
  }

  @media ${baseVariables.mediaQuery.lg} {
    &.pos-1 {
      grid-column: 1;
    }
    &.pos-2 {
      grid-column: 2;
    }
    &.pos-3 {
      grid-column: 3;
    }
  }

  &.banner {
    /* Span all available columns across breakpoints */
    grid-column: 1 / -1;
    grid-row: span 1;
  }
  &.tall {
    grid-row: span 1;
    @media ${baseVariables.mediaQuery.lg} {
      grid-row: span 2;
    }
  }
  &.square {
    grid-row: span 1;
  }

  .riott-media_border_radius {
    img {
      border-radius: 16px;
    }
  }
`;
